import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import Link from "@mui/material/Link";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import MuiCard from "@mui/material/Card";
import { styled } from "@mui/material/styles";
import { SitemarkIcon } from "../../components/CustomIcons";
import { useSearchParams } from "react-router-dom";
import { callBackendApi } from "../../methods/axiosInstances/backendInstance/apiRequest";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../store/snackbarSlice/snackbarSlice";

const Card = styled(MuiCard)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignSelf: "center",
  width: "100%",
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  margin: "auto",
  [theme.breakpoints.up("sm")]: {
    maxWidth: "450px",
  },
  boxShadow:
    "hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px",
  ...theme.applyStyles("dark", {
    boxShadow:
      "hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px",
  }),
}));

const SignInContainer = styled(Stack)(({ theme }) => ({
  height: "calc((1 - var(--template-frame-height, 0)) * 100dvh)",
  minHeight: "100%",
  padding: theme.spacing(2),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(4),
  },
  "&::before": {
    content: '""',
    display: "block",
    position: "absolute",
    zIndex: -1,
    inset: 0,
    backgroundImage:
      "radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))",
    backgroundRepeat: "no-repeat",
    ...theme.applyStyles("dark", {
      backgroundImage:
        "radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))",
    }),
  },
}));

export default function SignIn() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token"); // Get token from query params
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [passwordConfirm, setPasswordConfirm] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [errors, setErrors] = React.useState([]);
  const dispatch = useDispatch();

  const onSubmit = async (e) => {
    setMessage("");
    setErrors([]);
    e.preventDefault();
    if (password !== passwordConfirm) {
      setMessage("Passwords do not match.");
      return;
    }

    const response = await callBackendApi("/reset-password", "POST", {
      token,
      email,
      password,
      password_confirmation: passwordConfirm,
    });
    if (response.success) {
      dispatch(showSnackbar({ message: "Password changed!" }));
      return;
    } else {
        setErrors(response.error)
        console.log(response)
        // setMessage(response.data.message);
    }
    
  };
  React.useEffect(() => {
    if (!token) {
      setMessage("Invalid or missing reset token.");
    }
  }, [token]);

  return (
    <SignInContainer direction="column" justifyContent="space-between">
      <Card variant="outlined">
        <SitemarkIcon />
        <Typography
          component="h1"
          variant="h4"
          sx={{ width: "100%", fontSize: "clamp(2rem, 10vw, 2.15rem)" }}
        >
          Reset Password
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            gap: 2,
          }}
        >
          <FormControl>
            <FormLabel htmlFor="email">Email</FormLabel>
            <TextField
              id="email"
              type="email"
              name="email"
              helperText={errors.email ? errors?.email[0] : null}
              className={errors.email ? "error" : "primary"}
              placeholder="your@email.com"
              autoComplete="email"
              autoFocus
              required
              fullWidth
              value={email}
              variant="outlined"
              onChange={(e) => setEmail(e.target.value)}
            />
          </FormControl>
          <FormControl>
            <FormLabel htmlFor="password">Password</FormLabel>
            <TextField
              name="password"
              placeholder="••••••"
              type="password"
              id="password"
              helperText={errors.password ? errors?.password[0] : null}
              className={errors.password ? "error" : "primary"}
              autoFocus
              required
              fullWidth
              value={password}
              variant="outlined"
              onChange={(e) => setPassword(e.target.value)}
            />
          </FormControl>
          <FormControl>
            <FormLabel htmlFor="passwordConfirm">Password Confirm</FormLabel>
            <TextField
              name="passwordConfirm"
              placeholder="••••••"
              type="password"
              id="passwordConfirm"
              autoFocus
              required
              fullWidth
              value={passwordConfirm}
              variant="outlined"
              onChange={(e) => setPasswordConfirm(e.target.value)}
            />
          </FormControl>
          {message && <p>{message}</p>}
          <Button
            type="button"
            fullWidth
            variant="contained"
            onClick={onSubmit}
          >
            Reset Password
          </Button>
        </Box>
      </Card>
    </SignInContainer>
  );
}
